import React, { useState, useEffect } from 'react';
import ContentLoader from 'react-content-loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronUp,
  faStethoscope,
} from '@fortawesome/free-solid-svg-icons';
import { Link, useHistory } from 'react-router-dom';

import {
  BtnPeticiones,
  CarouselItem,
  ContCarousel,
  ContMenuLinksTwo,
  InfoMobile,
  SelectButton,
  Span,
  Svg,
} from './headerMobile.elements';
import useConfigs from '../hooks/useConfigs';
import useThemes from '../hooks/useThemes';
import { useApi } from '../hooks/useApi';

const HeaderMobile = () => {
  const {
    banners,
    contacto,
    getContacto,
    getBanners,
    opcionesMenu,
    getOpcionesMenu,
  } = useApi();
  const { data } = contacto;
  const { fontSizeMultiplier, theme, themeSelected } = useConfigs();
  const history = useHistory();
  const {
    backgroundQuinto,
    backgroundSexto,
    backgroundCuarto,
    backgroundSeptimo,
    colorSecundario,
    colorPrincipal,
  } = useThemes();

  const [buttonSelected, setButtonSelected] = useState(false);

  const handleClickButton = () => {
    setButtonSelected((prevState) => !prevState);
  };

  useEffect(() => {
    getContacto();
    getOpcionesMenu();
    getBanners();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const textButtonSecondary = opcionesMenu?.data?.secundario.find(
    (element) => element.rutaOpcion === '/pqr'
  );

  return (
    <header style={{ position: 'relative' }}>
      <ContCarousel
        style={{ margin: 0 }}
        nextIcon={
          <Span>
            <img src='img/Iconos/SVG/flecha-derecha.svg' alt='flecha derecha' />
          </Span>
        }
        prevIcon={
          <Span>
            <img
              src='img/Iconos/SVG/flecha-izquierda.svg'
              alt='flecha izquierda'
            />
          </Span>
        }
      >
        {banners.isLoading ? (
          <CarouselItem isLoading={banners.isLoading}>
            <ContentLoader
              speed={2}
              width='100%'
              height={560}
              foregroundColor={backgroundSexto}
              backgroundColor='#f7f7f7'
            />
          </CarouselItem>
        ) : (
          banners.data.bannerList.map((item) => (
            <CarouselItem
              name='carousel-item'
              isLoading={banners.isLoading}
              // src={item.imagen}
              key={item.id}
              fontSizeMultiplier={fontSizeMultiplier}
              background={backgroundQuinto}
              backgroundoption={backgroundCuarto}
              // color={backgroundSexto}
              colorprincipal={colorPrincipal}
              onClick={(event) => {
                const name = event.target.getAttribute('name');

                if (name === 'carousel-item' && item?.link?.length > 3) {
                  window.open(item.link);
                }
              }}
            >
              <div
                className='imgCarousel'
                onClick={() => {
                  if (item?.link?.length > 3) {
                    window.open(item.link);
                  }
                }}
              >
                <img src={item.imagen} alt={item.titulo} />
              </div>

              <InfoMobile
                fontSizeMultiplier={fontSizeMultiplier}
                theme={theme}
                themeSelected={themeSelected}
                className='row info'
              >
                <div className='col-md-12'>
                  <div className='row col-12'>
                    <SelectButton
                      fontSizeMultiplier={fontSizeMultiplier}
                      theme={theme}
                      themeSelected={themeSelected}
                      buttonSelected={buttonSelected}
                      className='col-12'
                      onClick={() => {
                        handleClickButton();
                      }}
                    >
                      <div className='cont-options row'>
                        <div className='d-flex align-items-center'>
                          <FontAwesomeIcon
                            icon={faStethoscope}
                            color={
                              themeSelected === 'light'
                                ? theme.blanco
                                : theme.blanco
                            }
                            size='2x'
                          />
                          <h2>Programar cita</h2>
                        </div>
                        <FontAwesomeIcon
                          icon={
                            buttonSelected === false
                              ? faChevronDown
                              : faChevronUp
                          }
                          color='#fff'
                          className='iconRow'
                        />
                      </div>
                    </SelectButton>

                    {buttonSelected && (
                      <div className='options-container'>
                        {data.dataAllContact.map((item, index) =>
                          item.nombreOpcion.includes('Facebook') ? (
                            ''
                          ) : item.nombreOpcion.includes('Sedes') ? (
                            ''
                          ) : item.rutaOpcion.includes('/contacto') ? (
                            ''
                          ) : item.rutaOpcion.includes('http') ? (
                            <a
                              className='contact-btn'
                              key={item.id}
                              href={
                                item.rutaOpcion.includes('http')
                                  ? item.rutaOpcion
                                  : `mailto:${item.nombreOpcion}`
                              }
                              target='_blank'
                              rel='noreferrer'
                            >
                              <p>{item.nombreOpcion}</p>
                            </a>
                          ) : (
                            <div
                              className='contact-btn'
                              key={item.id}
                              onClick={() => history.push(item.rutaOpcion)}
                            >
                              <p>{item.nombreOpcion}</p>
                            </div>
                          )
                        )}
                      </div>
                    )}

                    {opcionesMenu?.data?.secundario.find(
                      (element) => element.rutaOpcion === '/pqr'
                    ) && (
                      <BtnPeticiones
                        color={colorSecundario}
                        background={backgroundSeptimo}
                        className='col-5'
                        onClick={() => history.push('/pqr')}
                      >
                        {`${textButtonSecondary.nombreOpcion
                          .charAt(0)
                          .toUpperCase()}${textButtonSecondary.nombreOpcion
                          .slice(1, textButtonSecondary.nombreOpcion.length - 1)
                          .toLowerCase()
                          .replace('pqrs', 'PQRS')
                          .replace('pqr', 'PQR')}`}
                      </BtnPeticiones>
                    )}

                    <ContMenuLinksTwo
                      fontsizemultiplier={fontSizeMultiplier}
                      background={backgroundSeptimo}
                      color={colorPrincipal}
                    >
                      {banners.data.menuBanners.map((item) => (
                        <div key={item.id} className='cont-item-menu-flotante'>
                          <Link to={item.rutaOpcion}>
                            <div className='cont-img'>
                              <img
                                className='imgIcon'
                                src='./img/Iconos/SVG/d-humano.svg'
                                alt='opción Famedic'
                              />
                            </div>
                            <div className='aLink'>
                              <Link to={item.rutaOpcion}>
                                {item.nombreOpcion}
                              </Link>
                            </div>
                          </Link>
                        </div>
                      ))}
                    </ContMenuLinksTwo>
                  </div>
                </div>
              </InfoMobile>
            </CarouselItem>
          ))
        )}
      </ContCarousel>

      <Svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'>
        <path
          fill={backgroundSexto}
          d='M0,192L48,186.7C96,181,192,171,288,170.7C384,171,480,181,576,186.7C672,192,768,192,864,197.3C960,203,1056,213,1152,181.3C1248,149,1344,75,1392,37.3L1440,0L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z'
        ></path>
      </Svg>
    </header>
  );
};

export default HeaderMobile;
